import React from 'react';
import Chart from 'react-apexcharts';
import { useTheme } from '@mui/material/styles';
import { Stack, Typography, Avatar } from '@mui/material';
import { IconArrowUpRight } from '@tabler/icons';
import DashboardCard from '../../shared/DashboardCard';

const NewBookingsPerYear = ({ totalBookings }) => {
  const theme = useTheme();
  const primary = theme.palette.primary.main;
  const successlight = theme.palette.success.light;

  const optionscolumnchart = {
    chart: {
      type: 'bar',
      fontFamily: "'Plus Jakarta Sans', sans-serif;",
      foreColor: '#adb0bb',
      toolbar: { show: false },
      height: 80,
      resize: true,
      barColor: '#fff',
      sparkline: { enabled: true },
      events: {
        mouseMove: () => false,
        mouseLeave: () => false
      }
    },
    colors: [primary],
    grid: { show: false },
    plotOptions: {
      bar: {
        horizontal: false,
        startingShape: 'flat',
        endingShape: 'flat',
        columnWidth: '60%',
        barHeight: '20%',
        borderRadius: 3,
      },
    },
    dataLabels: { enabled: false },
    stroke: { show: true, width: 2.5, colors: ['rgba(0,0,0,0.01)'] },
    xaxis: { axisBorder: { show: false }, axisTicks: { show: false }, labels: { show: false } },
    yaxis: { labels: { show: false } },
    axisBorder: { show: false },
    fill: { opacity: 1 },
    tooltip: {
      enabled:false,
      theme: theme.palette.mode === 'dark' ? 'dark' : 'light',
      x: { show: false },
    },
  };
  const seriescolumnchart = [{ name: '', data: [4, 10, 9, 7, 9, 10, 11, 8, 10] }];

  return (
    <DashboardCard>
      <>
        <Typography variant="h6" color="textSecondary">New Bookings</Typography>
        <Typography variant="caption" color="textSecondary" sx={{ display: 'block', mt: 0.5 }}>This Year</Typography>
        <Stack direction="row" spacing={1} my={1} alignItems="center">
          <Typography variant="h5">{totalBookings}</Typography>
          <Avatar sx={{ bgcolor: successlight, width: 24, height: 24 }}>
            <IconArrowUpRight width={18} color="#39B69A" />
          </Avatar>
          {/* <Typography variant="subtitle2" fontWeight="600">+9%</Typography> */}
        </Stack>
        {/* <Chart options={optionscolumnchart} series={seriescolumnchart} type="bar" height="30px" /> */}
      </>
    </DashboardCard>
  );
};

export default NewBookingsPerYear;